var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * One therapist the patient may pick as a preference (PRD #1343, RS-007), or
 * that the practice may reassign a hold to at confirm. A deliberately thin
 * projection: the therapist's opaque id (a selection token the patient sends
 * back) and their display name — nothing else about the therapist leaks.
 */
export class PatientBookingTherapistDto {
    therapistId;
    therapistName;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientBookingTherapistDto.prototype, "therapistId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientBookingTherapistDto.prototype, "therapistName", void 0);
//# sourceMappingURL=patient-booking-therapist.dto.js.map